/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React, { FunctionComponent } from 'react';
import Link from 'next/link';
import Image from 'next/image';
import * as styles from './ArticleVerticalCard.style';
import { URLObject } from '../../utils/links';

export interface ArticleVerticalCardProps {
  title: string,
  abstract?: string,
  dataRef?: string,
  urlObject: URLObject,
  onClick: (path: string) => void,
  imageURL: string,
  imageAlt: string,
}

const ArticleVerticalCard: FunctionComponent<ArticleVerticalCardProps> = ({
  title,
  abstract,
  dataRef = 'article-card',
  onClick,
  urlObject,
  imageURL,
  imageAlt,
}) => (
  <article
    data-ref={dataRef}
    onClick={() => onClick(urlObject.as)}
    css={styles.base}
  >
    <div css={styles.imageWrapper}>
      {imageURL ? (
        <Image
          src={imageURL}
          width={340}
          height={224}
          alt={imageAlt}
        />
      ) : (
        <div css={styles.imagePlaceholder} />
      )}
    </div>
    <div css={styles.info}>
      <h3
        css={styles.title}
        data-ref={`${dataRef}-title`}
      >
        <Link
          href={urlObject.url}
          as={urlObject.as}
        >
          {title}
        </Link>
      </h3>
      {abstract && (
        <p css={styles.abstract}>
          {abstract}
        </p>
      )}
    </div>
  </article>
);

export default ArticleVerticalCard;
